import { Modal } from "@/components/elements/Modal";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TCareIndustryValidationModalProps = {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export const CareIndustryValidationModal: FC<TCareIndustryValidationModalProps> = ({ open, onClose, onContinue }) => {
  return (
    <Modal isOpen={open} onClose={onClose} onOk={onContinue} labelClose="閉じる" labelOk="続行" width={500} title="注意">
      <Stack mb={2}>
        <Typography>分野が「介護」の場合、「介護日本語評価試験」の合格証明書が必要です。</Typography>
      </Stack>
    </Modal>
  );
};
